import React, { useEffect } from "react";
import ScrollTop from "../components/ScrollTop";

const ServiceDisclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="containers">
        <h1 style={{ color: "black" }}>DISCLAIMER FOR INTERACTIVE SERVICES</h1>
        <p>
          Halalmeats.Store, in partnership with local butchers and grocery
          stores, provides website services that showcase products available for
          purchase. These websites serve as a platform to display product
          information and include links directing users to our affiliated
          website, www.meatwala.co.uk, where purchases can be made. By using any
          interactive services provided herein, you are agreeing to comply with
          and be bound by the terms, conditions, and notices relating to its
          use.
        </p>
        {/* <h2>1. ABOUT US</h2> */}
        <p>
          <strong style={{ color: "black" }}>1. Lawful Use:</strong> As a
          condition of your use of this website and the interactive services
          contained therein, you represent and warrant to Halalmeats.Store that
          you will not use this website for any purpose that is unlawful or
          prohibited by these terms, conditions, and notices.
        </p>
        <p>
          <strong style={{ color: "black" }}>2. Disclosure Rights:</strong>{" "}
          Halalmeats.Store reserves the right at all times to disclose any
          information deemed necessary to satisfy any applicable law,
          regulation, legal process, or governmental request, or to edit, refuse
          to post, or remove any information or materials, in whole or in part.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            3. Accuracy of Information:
          </strong>{" "}
          The information, products, and services included on this website may
          contain inaccuracies or typographical errors. Changes are periodically
          added to the information herein. HalalMeats.Store may make
          improvements and/or changes to this website at any time. Advice
          received via this website should not be relied upon for personal,
          legal, or financial decisions, and you should consult an appropriate
          professional for specific advice tailored to your situation.
        </p>
        <p>
          {" "}
          <strong style={{ color: "black" }}>
            4. Third-Party Transactions:
          </strong>{" "}
          Halalmeats.Store does not process transactions directly. Any purchases
          made through the showcased products on this website are redirected to
          www.meatwala.co.uk, where the transaction is completed.
          Halalmeats.Store or its partner store is not responsible for any
          transactions, issues, or disputes that may arise from purchases made
          on www.meatwala.co.uk.
        </p>
        <p>
          {" "}
          <strong style={{ color: "black" }}>5. No Warranties:</strong>{" "}
          Halalmeats.Store makes no representations about the suitability,
          reliability, timeliness, and accuracy of the information, products,
          and services contained on this website for any purpose. All such
          information, products, and services are provided "as is" without
          warranty of any kind.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            6. Disclaimer of Warranties:
          </strong>{" "}
          Halalmeats.Store hereby disclaims all warranties and conditions with
          regard to the information, products, and services contained on this
          website, including all implied warranties and conditions of
          merchantability, fitness for a particular purpose, title, and
          non-infringement.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            7. Limitation of Liability:
          </strong>{" "}
          In no event shall Halalmeats.Store be liable for any direct, indirect,
          punitive, incidental, special, consequential damages, or any damages
          whatsoever including, without limitation, damages for loss of use,
          data, or profits, arising out of or in any way connected:
          <br />
          - with the use or performance of this website,
          <br />
          - with the delay or inability to use this website,
          <br />
          - with the provision of or failure to provide services, or
          <br />- for any information, software, products, services, and related
          graphics obtained through this website, or otherwise arising out of
          the use of this website, whether based on contract, tort, strict
          liability, or otherwise, even if Halalmeats.Store has been advised of
          the possibility of damages.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            8. Jurisdictional Limitation:
          </strong>{" "}
          Due to the fact that certain jurisdictions do not permit or recognise
          an exclusion or limitation of liability for consequential or
          incidental damages, the above limitation may not apply to you. If you
          are dissatisfied with any portion of this website, or with any of
          these terms of use, your sole and exclusive remedy is to discontinue
          using this website.
        </p>
        <p>
          <strong style={{ color: "black" }}>9. Denial of Access:</strong>{" "}
          Halalmeats.Store reserves the right, in its sole discretion, to deny
          any user access to this website, any interactive service herein, or
          any portion of this website without notice, and the right to change
          the terms, conditions, and notices under which this website is
          offered.
        </p>
        <p>
          <strong style={{ color: "black" }}>10. Entire Agreement:</strong> This
          Agreement contains the entire agreement between the parties relating
          to the subject matter hereof and supersedes any and all prior
          agreements or understandings, written or oral, between the parties
          related to the subject matter hereof. No modification of this
          Agreement shall be valid unless made in writing and signed by both
          parties.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            11. E-Commerce Transactions & Responsibility:
          </strong>{" "}
          HalalMeats.Store does not sell or process transactions directly. Any
          purchases made through the showcased products on this website are
          redirected to www.meatwala.co.uk, which is solely responsible for
          transaction processing, order fulfillment, refunds, and customer
          support. Customers should review www.meatwala.co.uk’s terms and
          conditions before completing a purchase.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            {" "}
            12. Accuracy of Product Listings:
          </strong>{" "}
          HalalMeats.Store provides product listings as a service for local
          butchers and grocery stores. While we strive to ensure the accuracy of
          product descriptions, pricing, and availability, we do not guarantee
          their completeness or correctness. Any discrepancies should be
          addressed with the respective supplier.
        </p>
        <p>
          <strong style={{ color: "black" }}>
            13. Data Protection & Privacy:
          </strong>{" "}
          HalalMeats.Store complies with UK data protection laws, including the
          UK GDPR and the Data Protection Act 2018. By using this website, you
          consent to data processing as outlined in our Privacy Policy,
          available [insert link to privacy policy].
        </p>
        <p>
          <strong style={{ color: "black" }}>
            14. Dispute Resolution & Consumer Rights:
          </strong>{" "}
          All transactions made through www.meatwala.co.uk are subject to UK
          consumer protection laws, including the Consumer Rights Act 2015. If
          you have a dispute regarding a purchase, please contact
          www.meatwala.co.uk’s customer service.
        </p>
        <p>
          <strong style={{ color: "black" }}>15. Governing Law:</strong> This
          Agreement shall be governed by and construed in accordance with the
          laws of the United Kingdom.
        </p>
        <p>
          <strong style={{ color: "black" }}>16. Binding Effect:</strong> This
          Agreement shall be binding upon all who use Halalmeats.Store or its
          partners stores through Halalmeats.Store services, property, and other
          assets mentioned in this agreement with respect to this website and
          associated content. It supersedes all prior or contemporaneous
          communications and proposals, whether electronic, oral, or written,
          with respect to this website. A printed version of this agreement and
          of any notice given in electronic form shall be admissible in judicial
          or administrative proceedings based upon or relating to this agreement
          to the same extent and subject to the same conditions as other
          business documents and records originally generated and maintained in
          printed form. Any rights not expressly granted herein are reserved.
        </p>
      </div>
      <ScrollTop />
    </>
  );
};

export default ServiceDisclaimer;
